import { isKeyInDictionary, type PrematchFilterFromBack } from '../../types';

import type { tFunction } from 'app/lang';
import { DATA_GA_EVENT, SEARCH_PARAM_KEY, TEMPLATE } from 'app/modules/TimeFilter/constants';

import dictionary from 'app/modules/TimeFilter/TimeFilter.dictionary.json';

type GetTabsResult = {
  id: string;
  label: string;
  to: string;
  dataGaValues: {
    'data-ga-event': string;
    'data-ga-event-value': string;
  };
};

type getTabsProps = {
  t: tFunction;
  prematchFilterFromBack: PrematchFilterFromBack[];
  extraFilters?: {
    pop?: GetTabsResult[];
    push?: GetTabsResult[];
  };
};

type GetTabs = (props: getTabsProps) => GetTabsResult[];

export const getTabs: GetTabs = ({
  prematchFilterFromBack,
  t,
  extraFilters,
}) => {
  const result: GetTabsResult[] = [];

  if (extraFilters?.pop) {
    extraFilters?.pop.forEach((filter) => {
      const label = isKeyInDictionary(filter.id)
        ? t(dictionary[filter.id])
        : filter.id;

      result.push({
        ...filter,
        label,
      });
    });
  }

  prematchFilterFromBack.forEach((filter) => {
    const dictionaryKey = TEMPLATE[filter.template];
    const label = isKeyInDictionary(dictionaryKey)
      ? t(dictionary[dictionaryKey], { count: filter.output })
      : `${filter.output}${dictionaryKey}`;

    result.push({
      id: String(filter.value),
      label,
      to: `?${SEARCH_PARAM_KEY}=${filter.value}`,
      dataGaValues: {
        ['data-ga-event']: DATA_GA_EVENT,
        ['data-ga-event-value']: String(filter.value),
      },
    });
  });

  if (extraFilters?.push) {
    extraFilters?.push.forEach((filter) => {
      const label = isKeyInDictionary(filter.id)
        ? t(dictionary[filter.id])
        : filter.id;

      result.push({
        ...filter,
        label,
      });
    });
  }

  return result;
};
